import { useContainer } from '../../../hooks/useContainer';
import { AuthApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

export interface SignUpValues {
    email: string;
    password: string;
    givenName: string;
    familyName: string;
}

const useHttpPostSignUp = () => {
    const { t } = useTranslation('newNotifications');
    const authApi: AuthApi = useContainer(AuthApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (values: SignUpValues, callback: ICallback) => {
        const { exec, abort } = authApi.signUp({
            body: {
                email: values.email,
                password: values.password,
                givenName: values.givenName,
                familyName: values.familyName,
            },
            onSuccess: () => {
                toastHandler.push('success', t('auth.signUpTitle'), t('auth.signUpMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: (error: AppError | string) => {
                if (typeof error === 'object' && isErrorCode(error, ErrorCodes.RESOURCE_ALREADY_EXISTS)) {
                    toastHandler.push('error', t('auth.signUpFailedTitle'), t('auth.signUpFailedMessage_FailedAlreadyExist'));
                    navigate(`/sign-in`);
                } else {
                    const message = getUserMessage(error, t('common.error'));
                    toastHandler.push('error', t('auth.signUpFailedTitle'), message);
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostSignUp;
